const isObjectEmpty = (objToCheck) => {
    return objToCheck && Object.keys(objToCheck).length === 0 && objToCheck.constructor === Object;
}

export { isObjectEmpty }